export const isSizeFilter = (field, value) => {
  return (
    field === 'ss_instock_sizes' ||
    field === 'filter.v.option.size' ||
    field === 'size' ||
    field.toLowerCase().includes('size') ||
    value?.includes('-') ||
    value?.includes(',')
  )
}

const parseSizeValue = (sizeValue, sizeType) => {
  if (!sizeValue) return sizeValue

  if (!sizeValue.includes('-')) {
    return sizeValue
  }

  const regions = sizeValue.split('-').map(r => r.trim()).filter(r => r)

  for (const region of regions) {
    const cleanRegion = region.trim()

    if (sizeType === 'UK' && cleanRegion.startsWith('UK ')) {
      const ukContent = cleanRegion.replace('UK ', '').trim()
      if (ukContent.includes('/')) {
        return ukContent
      }
      return ukContent
    }

    if (sizeType === 'US' && cleanRegion.startsWith('US ')) {
      const usContent = cleanRegion.replace('US ', '').trim()
      if (usContent.includes('/')) {
        return usContent
      }
      return usContent
    }

    if (sizeType === 'EU' && cleanRegion.startsWith('EURO ')) {
      return cleanRegion.replace('EURO ', '').trim()
    }

    if (sizeType === 'CM' && cleanRegion.startsWith('CM ')) {
      return cleanRegion.replace('CM ', '').trim()
    }
  }

  return sizeValue
}

export const formatUniversalSizeValue = (value) => {
  if (!value?.includes('-')) {
    return value
  }

  const preferredSizeRange = localStorage.getItem('preferred_size_range') || 'EU'
  const parsedSize = parseSizeValue(value, preferredSizeRange)

  if (parsedSize && parsedSize !== value) {
    const sizeTypeLabel = preferredSizeRange === 'EU' ? 'EU' : preferredSizeRange
    return `${sizeTypeLabel} ${parsedSize}`
  }

  return value
}
